import { __decorate } from "tslib";
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { getTableList, delListItem, againIssued } from '@blade-sxp/its-management/api/detail';
import { DialogType } from '@blade-sxp/its-management/interfaces/index';
import colors from '@/styles/color.scss';
import addDetail from '@blade-sxp/its-management/components/detail/add-detail.vue';
import errDetail from '@blade-sxp/its-management/components/detail/err-detail.vue';
import InputSearch from '@blade-sxp/its-management/components/input-search.vue';
let default_1 = class default_1 extends Vue {
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    keyword = '';
    libType = '';
    // table 相关
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    devicesList = [];
    tableLoading = false;
    tableBtnLoading = {};
    // table 查询条件
    filterStatus = [];
    createTimeSort = 'ASC'; // 'ASC' / DESC
    updateTimeSort = 'ASC';
    // 弹窗
    itemDeviceId = 0;
    dialogVisible = false;
    type = DialogType.ADD; // add /edit
    uploadingStatus = {};
    colors = colors;
    defaultIconSize = 12;
    errDialog;
    errDialogVisible = false;
    initI18n() {
        this.filterStatus = [
            { text: String(this.$t('TrafficBlackList')), value: 'TrafficBlackList' },
            { text: String(this.$t('TrafficRedList')), value: 'TrafficRedList' },
        ];
    }
    onKeyChange() {
        this.onSearch();
    }
    mounted() {
        this.getList('createTime');
        this.initI18n();
    }
    onSearch(prop = 'createTime') {
        this.pagination.page = 1;
        this.getList(prop);
    }
    getParams(prop = 'createTime') {
        let pageOrderList = [
            {
                orderField: 'createTime',
                orderType: this.createTimeSort,
            },
        ];
        if (prop === 'createTime') {
            pageOrderList = [
                {
                    orderField: 'createTime',
                    orderType: this.createTimeSort,
                },
            ];
        }
        if (prop === 'updateTime') {
            pageOrderList = [
                {
                    orderField: 'updateTime',
                    orderType: this.updateTimeSort,
                },
            ];
        }
        return {
            deviceId: this.$route.query.deviceId,
            labName: this.keyword,
            libType: this.libType,
            page: this.pagination.page,
            size: this.pagination.size,
            pageOrderList,
        };
    }
    getList(prop) {
        this.tableLoading = true;
        const params = this.getParams(prop);
        try {
            getTableList(params)
                .then((res) => {
                this.devicesList = res.list;
                this.pagination.total = res.total;
            })
                .finally(() => {
                this.tableLoading = false;
            });
        }
        catch (error) {
            console.log('getList err', error);
            this.tableLoading = false;
        }
    }
    // pageSize 改变时会触发
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getList('createTime');
    }
    // currentPage 改变时会触发
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getList('createTime');
    }
    // 当表格的排序条件发生变化的时候会触发该事件
    onSortChange(column) {
        const { prop, order } = column;
        // console.log('columncolumncolumn', column);
        if (prop === 'createTime') {
            if (order === 'ascending') {
                this.createTimeSort = 'ASC';
            }
            else {
                this.createTimeSort = 'DESC';
            }
            this.onSearch('createTime');
        }
        if (prop === 'updateTime') {
            if (order === 'ascending') {
                this.updateTimeSort = 'ASC';
            }
            else {
                this.updateTimeSort = 'DESC';
            }
            this.onSearch('updateTime');
        }
    }
    // 当选择项发生变化时会触发该事件
    handleSelectionChange() {
        this.getList('createTime');
    }
    // 当表格的筛选条件发生变化的时候会触发该事件
    handleFilterChange(filters) {
        const { libType } = filters;
        if (libType) {
            this.libType = libType[0];
        }
        this.getList('createTime');
    }
    isResultCount(item) {
        let { failCount, successCount, totalCount } = item;
        failCount = +failCount;
        successCount = +successCount;
        totalCount = +totalCount;
        if (totalCount === 0)
            return false;
        return (failCount === 0 && successCount === 0) || totalCount === 0;
    }
    // 删除
    onDel(row) {
        // console.log('删除', row);
        this.$elconfirm(`${this.$t('confirmDelete').toString()} ${name}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: async (action) => {
                if (action === 'confirm') {
                    // console.log(action);
                    this.tableBtnLoading[row.id] = true;
                    this.tableBtnLoading = { ...this.tableBtnLoading };
                    try {
                        delListItem(row)
                            .then((res) => {
                            this.onSearch();
                            this.$elmessage.success(`${this.$t('successDelete').toString()}`);
                        })
                            .finally(() => {
                            this.tableBtnLoading[row.id] = false;
                            this.tableBtnLoading = { ...this.tableBtnLoading };
                        });
                    }
                    catch (error) {
                        console.log('onDel err', error);
                        this.tableBtnLoading[row.id] = false;
                        this.tableBtnLoading = { ...this.tableBtnLoading };
                    }
                }
            },
        });
    }
    onErrorDialog(row) {
        this.errDialogVisible = true;
        this.$nextTick(() => {
            const thisRow = Object.assign({}, row, { deviceId: this.$route.query.deviceId });
            this.$refs.errDialog.getList(thisRow);
        });
    }
    // 新增
    onAdd() {
        this.dialogVisible = true;
        this.type = DialogType.ADD;
    }
    // 新增成功
    addDeviceSuccess() {
        this.$emit('msgSuccess');
        this.getList('createTime');
    }
    changeType() {
        this.type = DialogType.EDIT;
    }
    // 重新下发
    onRefresh(row) {
        // const index = this.devicesList.findIndex((item) => {
        //   return item.libId === row.libId;
        // });
        this.uploadingStatus = {
            ...this.uploadingStatus,
            [row.libId]: true,
        };
        // this.devicesList[index].refresh = true;
        // this.devicesList = [...this.devicesList];
        try {
            againIssued(row).then(() => {
                this.$elmessage.success(`${this.$t('successIssued').toString()}`);
            });
            // .finally(() => {
            //   // this.devicesList[index].refresh = false;
            // });
        }
        catch (error) {
            console.log('onRefresh err', error);
            // this.devicesList[index].refresh = false;
            // this.devicesList = [...this.devicesList];
        }
    }
};
__decorate([
    Ref()
], default_1.prototype, "errDialog", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
__decorate([
    Watch('keyword')
], default_1.prototype, "onKeyChange", null);
default_1 = __decorate([
    Component({
        components: {
            addDetail,
            errDetail,
            InputSearch,
        },
        i18n: {
            messages: {
                'en-us': {
                    keywordPlaceholder: 'Vehicle Library Name',
                    add: 'Add',
                    total: 'Total {msg} Items',
                    // table
                    libName: 'Vehicle Library',
                    type: 'Type',
                    createBy: 'Created By',
                    createTime: 'Created At',
                    updateTime: 'Updated At',
                    result: 'Result',
                    action: 'Action',
                    delete: 'Delete',
                    ok: 'OK',
                    cancel: 'Cancel',
                    tip: 'Tip',
                    confirmDelete: 'Are you sure to delete the vehicle library from the list?',
                    successDelete: 'successfully delete',
                    tipText: 'Sending the failed image again',
                    TrafficBlackList: 'Black Library',
                    TrafficRedList: 'White Library',
                    warning: 'Warning',
                    successIssued: 'Re-publishing succeeded',
                    uploading: 'Uploading',
                    redistributionTip: 'Redistributed the failed vehicles',
                },
                zh: {
                    keywordPlaceholder: '请输入车库名称',
                    add: '新增',
                    total: '总共 {msg} 条',
                    // table
                    libName: '车辆库',
                    type: '类型',
                    createBy: '创建人',
                    createTime: '创建时间',
                    updateTime: '更新时间',
                    result: '下发结果',
                    action: '操作',
                    delete: '删除',
                    ok: '确定',
                    cancel: '取消',
                    tip: '提示',
                    confirmDelete: '确定要从列表中删除车辆库吗？',
                    successDelete: '删除成功',
                    tipText: '重新下发失败图片',
                    TrafficBlackList: '黑名单',
                    TrafficRedList: '白名单',
                    warning: '警告',
                    successIssued: '重新发布成功',
                    uploading: '上传中',
                    redistributionTip: '重新下发失败车辆',
                },
            },
        },
    })
], default_1);
export default default_1;
